<!--
  Validate Dialog
  유효성 검사 실패 다이얼로그

  @since 2018-04-05
  @author ms1124.kim
-->

<template>
  <q-dialog stack-buttons
            ref="validateDialog"
            v-model="isOpen"
            :ok="dialogOption.ok"
            :cancel="dialogOption.cancel"
            :class="classStyle()"
            @hide="onHide"
            @show="onShow">
    <div slot="body">
      <div class="dialog-body-group">
        <div class="contents-row">
          <p :class="dialogOption.iconClass"></p>
          <slot></slot>
          <p v-html="dialogOption.message"></p>
        </div>
      </div>
    </div>
  </q-dialog>
</template>

<script>
  // plugin component
  import {ValidatePopUp} from '~/plugins/components'

  export default {
    name: 'ValidateDialog',
    data () {
      return {
        isOpen: false,
        timer: [],
        dialogOption: {
          ok: true,
          type: 'completion',
          cancel: false,
          timeout: 3000,
          message: this.getBasicValidateMsg
        }
      }
    },
    computed: {
      getBasicValidateMsg () {
        return this.$t('msg.validateDialog_alert_basic')
      }
    },
    beforeMount () {
      ValidatePopUp.event.$on('show', (opts) => {
        this.show(opts)
      })

      ValidatePopUp.event.$on('hide', () => {
        this.hide()
      })
    },
    beforeDestroy () {
      ValidatePopUp.event.$off('show')
      ValidatePopUp.event.$off('hide')
    },
    methods: {
      classStyle () {
        let baseClass = ['bs', 'bs-q-dialog']
        return _.concat(baseClass, ['bs-q-dialog-' + this.dialogOption.type])
      },
      onHide () {
        // validationMixin을 연달아 호출할 경우 팝업이 중복으로 출력되기 때문에 timer를 배열로 지정 및 제거
        for (let i = 0; i < this.timer.length; i++) {
          clearTimeout(this.timer[i])
        }
        this.timer = []
        // Q-Dialog의 Hide 이벤트를 호출합니다. 대화창이 화면에서 사라집니다.
        this.$emit('hide')
      },
      onShow () {
        // Q-Dialog의 Show 이벤트를 호출합니다. 화면에 대화창이 출력됩니다.
        this.$emit('show')
      },
      show (errors, customErrors = []) {
        // 에러 타입이 리스트인 경우
        if (Array.isArray(errors)) {
          this.showArrayErrorbagMsg(errors, customErrors)
        } else if (typeof errors === 'object') {
          // 에러 타입이 Object인 경우
          this.showObjectErrorbagMsg(errors, customErrors)
        } else if (typeof errors === 'string') {
          // 에러 타입이 단일 문자열인 경우
          this.showStringErrorMsg(errors)
        } else {
          this.$log('[Validate dialog warn] : A type that can not be processed by the Validate Popup has been passed.')
        }
      },
      hide () {
        if (typeof this.$refs.validateDialog !== 'undefined') {
          this.$refs.validateDialog.hide()
        }
      },
      /*
        이름: showStringErrorMsg
        설명: 단일 에러메세지를 출력할 경우, 전달된 문자열로 팝업을 출력한다.
      */
      showStringErrorMsg (errorMsg) {
        // 에러메세지 설정
        this.dialogOption.message = errorMsg

        // 경고 메세지 출력
        this.$refs.validateDialog.show()

        // 설정된 시간 뒤에 팝업 숨김
        const _this = this

        // 1회성 타이머 설정
        this.timer.push(
          setTimeout(() => {
            _this.hide()
          }, _this.dialogOption.timeout)
        )
      },
      /*
        이름: showArrayErrorbagMsg
        설명: 파라미터로 에러백 메세지 리스트가 들어올 경우 해당 포맷으로 메세지를 출력한다.
      */
      showArrayErrorbagMsg (options) {
        // Options가 있다면 메세지 재구성
        if (options) {
          // 유효성 실패 메세지 저장 변수
          let validMsg = ''
          let errorBag = []

          // 메세지 중복 제거
          for (const errObj of options) {
            // 필드 속성이 있는경우 - Vee validate Error 객체
            if (errObj.field) {
              // 필드 이름에 ipv4seg 문자열이 들어가는 경우 - Vee validate에 등록된 IPv4 Error 객체
              if (errObj.field.indexOf('ipv4seg') > -1 || errObj.field.indexOf('@macSegment@') > -1) {
                // 필드이름 가져오기
                const splitIndex = errObj.field.lastIndexOf('_')
                const fieldKeyName = errObj.field.slice(0, splitIndex)

                // 대상 필드 이름이 이미 등록되었는지 검색
                const duplicateFieldName = errorBag.find((error) => {
                  if (error.field) {
                    if (error.field.indexOf(fieldKeyName) > -1) {
                      return true
                    }
                  }

                  return false
                })

                // 이미 등록된 이름이라면 continue
                if (duplicateFieldName) {
                  continue
                }
              }
            }

            // 에러 등록
            errorBag.push(errObj)
          }

          // 에러 메세지 추가
          for (const error of errorBag) {
            validMsg += error.msg + '<br/>'
          }

          // 다이얼로그 메세지에 에러메세지 등록
          this.dialogOption.message = validMsg
        }

        // 경고 메세지 출력
        this.$refs.validateDialog.show()

        // 1회성 타이머 설정 - 지정된 시간 뒤에 팝업이 자동으로 닫힌다.
        const _this = this
        this.timer.push(
          setTimeout(() => {
            _this.hide()
          }, _this.dialogOption.timeout)
        )
      },
      /*
        이름: showObjectErrorbagMsg
        설명: 에러백 객체가 전달되면 vmId로 구분하여 메세지를 출력한다.
      */
      showObjectErrorbagMsg (errors, customErrors = []) {
        // Validate ErrorBag이 전달되었다면 메세지 구성
        if (errors) {
          // 유효성 실패 메세지 저장 변수
          let validMsg = ''
          let errorBag = []

          // 현재 ErrorBag의 ID 저장
          const errorBagId = errors.vmId

          // 메세지 중복 제거
          for (const errObj of errors.items) {
            // 에러 메세지가 ErrorBag의 ID와 동일한지 확인
            if (errorBagId === errObj.vmId) {
              // 필드 속성이 있는경우 - Vee validate Error 객체
              if (errObj.field) {
                // 필드 이름에 ipv4seg 문자열이 들어가는 경우 - Vee validate에 등록된 IPv4 Error 객체
                if (errObj.field.indexOf('ipv4seg') > -1 || errObj.field.indexOf('@macSegment@') > -1) {
                  // 필드이름 가져오기
                  const splitIndex = errObj.field.lastIndexOf('_')
                  const fieldKeyName = errObj.field.slice(0, splitIndex)

                  // 대상 필드 이름이 이미 등록되었는지 검색
                  const duplicateFieldName = errorBag.find((error) => {
                    if (error.field) {
                      if (error.field.indexOf(fieldKeyName) > -1) {
                        return true
                      }
                    }

                    return false
                  })

                  // 이미 등록된 이름이라면 continue
                  if (duplicateFieldName) {
                    continue
                  }
                }
              }

              // 에러 등록
              errorBag.push(errObj)
            }
          }

          // 커스텀 에러 객체가 있는 경우
          if (customErrors.length > 0) {
            // 커스텀 에러도 리스트에 추가
            errorBag = [...errorBag, ...customErrors]
          }

          // 에러 메세지 변환
          for (const error of errorBag) {
            validMsg += error.msg + '<br/>'
          }

          // 다이얼로그 메세지에 에러메세지 등록
          this.dialogOption.message = validMsg
        }

        // 경고 메세지 출력
        this.$refs.validateDialog.show()

        // 커스텀 메세지 초기화
        customErrors = []

        // 지정된 시간이 지나면 자동으로 메세지 팝업 숨김
        const _this = this

        // 1회성 타이머 동작
        this.timer.push(
          setTimeout(() => {
            _this.hide()
          }, _this.dialogOption.timeout)
        )
      }
    }
  }
</script>
